const getSessionItem = () => {
    return sessionStorage.getItem("BF20HomeTopPicks")
};

const getDataFromStorage = () => {
    const sessionData = JSON.parse(sessionStorage.BF20HomeTopPicks);
    let productData;
    if (sessionData && sessionData.prodInfo) {
        productData = sessionData.prodInfo;        
        if (shopdirect && shopdirect.event) {
            shopdirect.event.publish('bf-home/top-picks', {
                'productData': productData
            });
        }
    }    
}

const setSessionItem = (topPicksInfo) => {
    let sessionData; 
    const sessionDate = new Date();
    sessionData = { 'date': sessionDate, 'prodInfo': topPicksInfo };
    sessionStorage.setItem('BF20HomeTopPicks', JSON.stringify(sessionData));
};

const isNewRequestRequired = () => {
    if (window.bf20.hasStorage) {
        const sessionValue = getSessionItem();
        const timeDiffThresold = window.bf20.sessionCacheTime * 1000 * 60;
        const currentDate = new Date();   
        
        if (sessionValue) {
            const sessionData = JSON.parse(sessionStorage.BF20HomeTopPicks)
            /* 
                Check Threshold Time Period has expired since last view 
            */
            if (Date.parse(currentDate) - Date.parse(sessionData.date) < timeDiffThresold) {            
                return false;
            } 
            return true;
        }    
    }
    return true;
};

export { setSessionItem, isNewRequestRequired, getDataFromStorage };